/* ==========================================================================
   STF DIAMONDS — nameplate-builder.js
   Live nameplate configurator (sections/stf-nameplate-builder.liquid).
   Pure DOM/CSS preview — no canvas, no external calls. The typed name is
   rendered as beveled gold text; lettering / karat / finish choices flip
   data attributes the CSS reacts to. The request CTA prefills the custom
   request modal (rendered by stf-custom-page) with the chosen config via
   hidden inputs + the vision textarea, then base.js's [data-open] handler
   opens it (this listener runs first because it is bound to the button).
   When the section wires a nameplate product instead, the CTA is a real
   add-to-cart form ([data-npb-atc-form]) and every render() syncs the
   config into its properties[...] hidden inputs (line-item properties);
   submit is blocked until a name is typed.
   ========================================================================== */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.npbInit) return;
    root.dataset.npbInit = 'true';

    var stage = root.querySelector('[data-npb-stage]');
    var nameEl = root.querySelector('[data-npb-name]');
    var input = root.querySelector('[data-npb-input]');
    var count = root.querySelector('[data-npb-count]');
    var cta = root.querySelector('[data-npb-request]');
    var atcForm = root.querySelector('[data-npb-atc-form]');
    if (!stage || !nameEl) return;

    var placeholder = nameEl.getAttribute('data-npb-placeholder') || 'Your Name';

    function picked(option) {
      var el = root.querySelector('[data-npb-option="' + option + '"]:checked');
      return el
        ? { value: el.value, label: el.getAttribute('data-npb-label') || el.value, el: el }
        : null;
    }

    function typedName() {
      return input ? input.value.trim().slice(0, 12) : '';
    }

    function setSpec(key, value) {
      var out = root.querySelector('[data-npb-spec="' + key + '"]');
      if (out) out.textContent = value;
    }

    function render() {
      var name = typedName();
      var shown = name || placeholder;
      var style = picked('style');
      var karat = picked('karat');
      var finish = picked('finish');
      var chain = picked('chain');
      var charm = picked('charm');
      var plate = picked('plate');

      nameEl.textContent = shown;
      nameEl.setAttribute('data-text', shown);
      if (count) count.textContent = String(name.length);

      stage.setAttribute('data-style', style ? style.value : 'script');
      stage.setAttribute('data-karat', karat ? karat.value : '14k');
      stage.classList.toggle('is-iced', !!finish && finish.value === 'iced');
      stage.setAttribute('data-plate', plate ? plate.value : 'single');

      setSpec('name', name || '—');
      if (style) setSpec('style', style.label);
      if (karat) setSpec('karat', karat.label);
      if (finish) setSpec('finish', finish.label);
      if (chain) {
        setSpec('chain', chain.label);
        var cimg = root.querySelector('[data-npb-chainimg]');
        var curl = chain.el && chain.el.getAttribute('data-npb-img');
        if (cimg && curl && cimg.getAttribute('src') !== curl) cimg.setAttribute('src', curl);
      }
      if (charm) {
        setSpec('charm', charm.label);
        var chimg = root.querySelector('[data-npb-charmimg]');
        var churl = charm.el && charm.el.getAttribute('data-npb-img');
        if (chimg) {
          if (churl) { chimg.setAttribute('src', churl); chimg.hidden = false; }
          else { chimg.hidden = true; }
        }
      }

      /* v4 live estimate */
      var pr = root.querySelector('[data-npb-pricing]');
      var estText = '';
      if (pr) {
        var karV = karat ? karat.value : '14k';
        var base = parseFloat(karV === '10k' ? pr.getAttribute('data-base-10k') : pr.getAttribute('data-base-14k')) || 0;
        var mult = 1;
        if (plate && plate.value === 'double') mult = parseFloat(pr.getAttribute('data-mult-double')) || 1.85;
        if (plate && plate.value === 'solid') mult = parseFloat(pr.getAttribute('data-mult-solid')) || 1.5;
        var letters = Math.max(0, (name || '').replace(/\s/g, '').length - 6);
        var per = parseFloat(pr.getAttribute('data-per-letter')) || 0;
        var iced = (finish && finish.value === 'iced') ? (parseFloat(pr.getAttribute('data-iced-add')) || 0) : 0;
        var est = Math.round((base + letters * per) * mult + iced);
        estText = '$' + est;
        var out = pr.querySelector('[data-npb-estimate]');
        if (out) out.textContent = 'Estimated: $' + est + ' \u2014 final quote confirmed same day';
      }

      /* Line-item properties: mirror the config into the add-to-cart form */
      if (atcForm) {
        setProp('name', name);
        setProp('style', style ? style.label : '');
        setProp('karat', karat ? karat.label : '');
        setProp('finish', finish ? finish.label : 'Polished');
        setProp('chain', chain ? chain.label : '');
        setProp('charm', charm ? charm.label : '');
        setProp('plate', plate ? plate.label : 'Single Plate');
        setProp('estimate', estText);
      }
    }

    function setProp(key, value) {
      var el = atcForm.querySelector('[data-npb-prop="' + key + '"]');
      if (el) el.value = value;
    }

    function requireName(e) {
      if (typedName()) return true;
      e.preventDefault();
      e.stopPropagation();
      if (input) {
        input.focus();
        input.classList.add('npb__name-input--attn');
        window.setTimeout(function () {
          input.classList.remove('npb__name-input--attn');
        }, 900);
      }
      return false;
    }

    /* Brief crossfade so gradient/font swaps read as a transition
       (background-clip gradients cannot animate between values). */
    var swapTimer = null;
    function renderWithFade() {
      if (reducedMotion) {
        render();
        return;
      }
      nameEl.classList.add('is-switching');
      window.clearTimeout(swapTimer);
      swapTimer = window.setTimeout(function () {
        render();
        nameEl.classList.remove('is-switching');
      }, 160);
    }

    if (input) {
      input.addEventListener('input', render);
    }
    root.querySelectorAll('[data-npb-option]').forEach(function (radio) {
      radio.addEventListener('change', renderWithFade);
    });

    /* ---- Request CTA: prefill + open the custom request modal ---- */

    function specRows() {
      var lines = [];
      root.querySelectorAll('.npb-spec__row').forEach(function (row) {
        var dt = row.querySelector('dt');
        var dd = row.querySelector('dd');
        if (dt && dd) lines.push(dt.textContent.trim() + ': ' + dd.textContent.trim());
      });
      return lines;
    }

    function setHidden(form, fieldName, value) {
      var sel = 'input[type="hidden"][name="' + fieldName + '"]';
      var el = form.querySelector(sel);
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = fieldName;
        form.appendChild(el);
      }
      el.value = value;
    }

    function prefill(modal) {
      var form = modal.querySelector('form');
      if (!form) return;

      var name = typedName();
      var style = picked('style');
      var karat = picked('karat');
      var finish = picked('finish');
      var chain = picked('chain');
      var charm = picked('charm');
      var plate = picked('plate');
      var title = (cta && cta.getAttribute('data-npb-summary-title')) || 'Custom Nameplate Request';
      var priceLine = root.querySelector('.npb__price-line');

      var lines = [title].concat(specRows());
      if (priceLine) lines.push(priceLine.textContent.trim());

      var vision = form.querySelector('[name="contact[Your Vision]"]');
      if (vision) vision.value = lines.join('\n');

      /* Preselect the "Nameplate" piece type if the modal offers it */
      form.querySelectorAll('input[name="contact[Piece Type]"]').forEach(function (radio) {
        if (radio.value.toLowerCase().indexOf('nameplate') > -1) radio.checked = true;
      });

      setHidden(form, 'contact[Nameplate Name]', name);
      setHidden(form, 'contact[Nameplate Style]', style ? style.label : '');
      setHidden(form, 'contact[Nameplate Gold]', karat ? karat.label : '');
      setHidden(form, 'contact[Nameplate Finish]', finish ? finish.label : 'Polished');
      setHidden(form, 'contact[Nameplate Chain]', chain ? chain.label : '');
      setHidden(form, 'contact[Nameplate Plate]', plate ? plate.label : 'Single Plate');
      setHidden(form, 'contact[Nameplate Charm]', charm ? charm.label : '');
    }

    if (atcForm) {
      /* Need a name before anything lands in the cart */
      atcForm.addEventListener('submit', requireName);
    }

    if (cta) {
      cta.addEventListener('click', function (e) {
        /* Need a name first — block base.js's document-level opener */
        if (!requireName(e)) return;

        var modal = document.querySelector('[data-custom-request]');
        if (!modal) {
          var fallback = cta.getAttribute('data-npb-fallback');
          if (fallback) {
            e.preventDefault();
            window.location.href = fallback;
          }
          return;
        }
        prefill(modal);
        /* base.js's [data-open] listener on document opens the modal next */
      });
    }

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nameplate-builder]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
